



























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import DroppoHoldButton from '@/views/components/openHub/DroppoHoldButton.vue';
import ShowHubInDropup from '@/views/components/openHub/ShowHubInDropup.vue';
import {OTHER_ROUTES} from "@/constants/routes";

const hubs = namespace('hubs');
const userDataModule = namespace("userData");

@Component({
  name: 'OpenHub',
  components: {
    DroppoHoldButton,
    ShowHubInDropup,
  },
})
export default class OpenHub extends Vue {
  @Prop({default: false})
  private loading!: boolean;

  @Prop({default: false})
  private openError!: boolean;

  @Prop({default: false})
  private finishOpen!: boolean;

  @Prop({default: '-'})
  private hubId!: number|null;

  @userDataModule.Getter('getOfficePhoneNumberLink')
  private getOfficePhoneNumberLink!: string;

  @hubs.Getter('getHubAddressById')
  private getHubAddressById!: (id: string|number) => string;

  // when we finish a shipment, the order disappears, making this value null. This mean that
  // after we open a locker, the address disappears. We want to show the address until the user finishes the process
  // of picking up the shipment, but also we want to be able to show the localization of the hub, so we need to
  // keep the hubId value somehow after the shipping has disappears. This variable has this function.
  private hubIdBackup: string|number|null = null;

  private showHubInMap: boolean = false;
  private finishReOpen: boolean = false;
  private restartOpen: boolean = false;
  private showReopen: boolean = false;

  private get hubAddress(): string {
    return this.cachedHubId ? this.getHubAddressById(this.cachedHubId) : '';
  }

  private get cachedHubId(): string|number|null {
    if (this.hubId) {
      this.hubIdBackup = this.hubId;
    }

    return this.hubIdBackup;
  }

  get finishedLoadedAndNoError() {
    return this.finishOpen && !this.loading && !this.openError;
  }

  get finishedButError() {
    return this.finishOpen && !this.loading && this.openError;
  }

  private backToStart() {
    this.$router.push({name: OTHER_ROUTES.HOME });
  }

  private goToThankYou() {
    this.$router.push({name: OTHER_ROUTES.THANK_YOU});
  }

  private proxyEvent(otherInfo: any) {
    this.$emit('open', otherInfo);
  }

  private reOpenProxyEvent(otherInfo: any) {
    this.$emit('reOpen', otherInfo);
  }

  private showMap() {
    this.$uiBus.emit("dropup:open", this.hubIdBackup);
  }

  private goToReopen() {
    this.finishReOpen = false;
    this.showReopen = true;
    this.restartOpen = false;
  }

  private resetOpen() {
    this.$emit('resetOpen');
  }

}
